/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';

import {
    BaseComp,
  BaseContent,
  DivSwiper,
  NewsDiv,
  TextBody,
  TextTitle,
} from './styles';
import Services from '../../../../../services/service';
import { Container, Content } from '../../../../../styles/components';

import { Navigation, Pagination, Scrollbar, A11y, Autoplay  } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import Imagem1 from '../../../../../assets/images/carrousel/IMG_1971.jpeg';
import Imagem2 from '../../../../../assets/images/carrousel/IMG_20250301_115115_1.jpg';
import Imagem3 from '../../../../../assets/images/carrousel/Imagemonibus.jpeg';
import Imagem4 from '../../../../../assets/images/carrousel/SetraBH_.jpg';
import Imagem5 from '../../../../../assets/images/carrousel/VISITA_RODOPASS.jpg';
import Imagem6 from '../../../../../assets/images/carrousel/VISITA_RODOPASS_2.jpg';
import Imagem7 from '../../../../../assets/images/carrousel/VISITA_RODOPASS_3.jpg';
import Imagem8 from '../../../../../assets/images/carrousel/_DSC9527.jpg';
import Imagem9 from '../../../../../assets/images/carrousel/_DSC9566.jpg';
import Imagem10 from '../../../../../assets/images/carrousel/_DSC9668.jpg';



import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { useMediaQuery } from '@mui/material';

interface Medias {
  media_id: number;
  media_url: string;
  permalink: string;
}

const HistoryCarrousel: React.FC = () => {
  const [medias, setMedias] = useState<Medias[]>([]);
  const [mobileMedias, setMobileMedias] = useState<Medias[]>([]);
  const services = { service: new Services() };

  const data = [
    {name:"Image1", value: Imagem1},
    {name:"Image2", value: Imagem2},
    {name:"Image3", value: Imagem3},
    {name:"Image4", value: Imagem4},
    {name:"Image5", value: Imagem5},
    {name:"Image6", value: Imagem6},
    {name:"Image7", value: Imagem7},
    {name:"Image8", value: Imagem8},
    {name:"Image9", value: Imagem9},
    {name:"Image10", value: Imagem10},
]

  const matches = useMediaQuery('(max-width:1000px)');

  const matches2 = useMediaQuery('(max-width:800px)');


  return (
    <BaseComp id='carrousel'>
        <BaseContent>
            <Swiper
                modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                spaceBetween={2}
                slidesPerView={matches2 ? 1 : matches ? 2 : 4}
                pagination={{
                    clickable: true,
                }}
                autoplay={{
                    delay: 1500,
                    disableOnInteraction: true,
                }}
                style={{
                    display: 'flex',
                    textAlign: 'center',
                    maxWidth: '100%',
                    height: '400px',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                {data.map((data:any, index: number) => (
                    <SwiperSlide
                        key={index}
                        style={{
                            width: matches2 ? '50%' : matches ? '50%' : '70%',
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <DivSwiper>
                            <img src={data?.value} width={matches2 ? 200 : matches ? 200 : 220 }/>
                        </DivSwiper>
                    </SwiperSlide>
                ))}
            </Swiper>
        </BaseContent>
    </BaseComp>
  );
};

export default HistoryCarrousel;
